import { render, staticRenderFns } from "./pop_up.vue?vue&type=template&id=efedc070&scoped=true"
import script from "./pop_up.vue?vue&type=script&lang=js"
export * from "./pop_up.vue?vue&type=script&lang=js"
import style0 from "./pop_up.vue?vue&type=style&index=0&id=efedc070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efedc070",
  null
  
)

export default component.exports